import {styled} from "@mui/material/styles";

export const DefaultAccountImage = '/assets/defaultAccountImg.png';
export const AvatarInput = styled('div')(({width, height}) => (`
  position: relative;
  align-self: center;
  img {
    width: ${width}px; //todo add props: width
    height: ${height}px; //todo add props: height
    object-fit: cover;
    border-radius: 50%;
  }
  .circle {
    width: ${width}px; //todo add props: width
    height: ${height}px; //todo add props: height
    border-radius: 50%;
  }
  label {
    right: 23em !important;
    position: absolute;
    width: 48px;
    height: 48px;
    background: #312e38;
    border-radius: 50%;
    bottom: 0;
    border: 0;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      display: none;
    }
    svg {
      width: 20px;
      height: 20px;
      color: #f4ede8;
    }
    &:hover {
      background: blue;
    }
  }
`));